<template>
  <div>
    <el-card>
      <el-input v-model="coinType" size="mini" class="search" placeholder="输入币种搜索"/>
      <el-input v-model="pair" size="mini" class="search" placeholder="输入交易对搜索"/>
      <el-select v-model="feeType" placeholder="手续费类型" size="mini">
          <el-option v-for="item in feeTypes" :label="item.desc" :key="item.code" :value="item.code"/>
      </el-select>
      <el-date-picker v-model="tradeTime" type="datetimerange" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" :picker-options="pickerOptions" size="mini"/>
      <el-button type="primary" icon="el-icon-search" @click="queryData()" circle size="mini"/>
      <el-table v-if="tableAble" :data="tradeFee">
        <el-table-column label="币种" prop="coinType"/>
        <el-table-column label="交易对" prop="pair"/>
        <el-table-column label="数额" prop="amount"/>
        <el-table-column label="时间" prop="tradeTime"/>
      </el-table>
    </el-card>

    <el-card>
      <div slot="header" class="clearfix">
        <el-form :inline="true">
          <el-form-item><span style="font-weight: bold">手续费统计</span></el-form-item>
          <el-form-item>
            <el-date-picker v-model="time" type="datetimerange" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" :picker-options="pickerOptions"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-input placeholder="请输入币种" v-model="statisticCoinType"/>
          </el-form-item>
          <el-form-item><el-button type="primary" @click="getFeeInfo()">查询</el-button></el-form-item>
        </el-form>
        <el-form :inline="true">
          <el-form-item label="总计：">{{feeInfo.allFee}}，</el-form-item>
          <el-form-item label="合约：">{{feeInfo.swapFee}}，</el-form-item>
          <el-form-item label="现货：">{{feeInfo.spotFee}}，</el-form-item>
          <el-form-item label="超级合约：">{{feeInfo.genFee}}，</el-form-item>
          <el-form-item label="LT：">{{feeInfo.ltFee}}</el-form-item>
        </el-form>
      </div>
    </el-card>

  </div>
</template>
<script>
import "../store.js";
import { mapState, mapActions } from "vuex";
import Pagination from "components/pagination";
import { formatTable } from "../../../common/tools.js";
import api from "../api";
export default {
  name: "dataCenterTradeFee",
  data() {
    return {
      coinType: "",
      feeType: '',
      pair: "",
      feeTypes:[{code:'SPOT',desc:'现货'},{code:'CONTRACT',desc:'合约'},{code:'GENERAL',desc:'超级合约'}],
      tradeTime:[],
      time:[],
      statisticCoinType: '',
      feeInfo:{
        allFee:0,
        swapFee:0,
        spotFee:0,
        ltFee:0,
        genFee:0,
      },
      pickerOptions:{
        shortcuts: [
          {
            text: '当天',
            onClick(picker) {
              const end = new Date();
              let year=end.getFullYear();
              let month=end.getMonth();
              let date=end.getDate();
              const start = new Date(year,month,date);
              start.setTime(start.getTime());
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近三天',
            onClick(picker) {
              const end = new Date();
              let year=end.getFullYear();
              let month=end.getMonth();
              let date=end.getDate();
              const start = new Date(year,month,date);
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 2);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              let year=end.getFullYear();
              let month=end.getMonth();
              let date=end.getDate();
              const start = new Date(year,month,date);
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit('pick', [start, end]);
            }
          },
        ]
      },
    };
  },
  methods: {
    ...mapActions("dataCenter", ["getAllCoins", "getTradeFeeTime"]),
    queryData() {
      let q = {};
      if (this.feeType) q.feeType = this.feeType;
      if (this.coinType) q.coinType = this.coinType;
      if (this.pair) q.pair = this.pair;
      if (this.tradeTime.length === 0){
        this.$message.error('时间参数不能为空');
        return;
      }
      if (this.tradeTime){
        q.startTime = this.tradeTime[0];
        q.endTime = this.tradeTime[1];
      }
      this.getTradeFeeTime(q);
    },
    getFeeInfo(){
      if (this.time.length === 0){
        this.$message.error('时间参数不能为空');
        return;
      }
      api.queryFee({startTime:this.time[0],endTime:this.time[1],coinType: this.statisticCoinType}).then(response =>{
        this.feeInfo = response.data;
      })
    }
  },
  computed: {
    ...mapState("dataCenter", ["allCoins", "tradeFee", "tableAble"]),
  },
  watch: {
    tradeFee() {
      formatTable();
    },
  },
  mounted() {},
};
</script>
<style scoped>
.search {
  width: 200px;
  margin: 0px 20px 20px 0px;
}
.date-search {
  margin-right: 20px;
}
.swt {
  margin-right: 20px;
}
</style>
